var cilArrowThickBottom = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M255.682,494.636,16,254.3V216.024l143.937-.007V16h192V216.007L495.952,216l-.035,38.688ZM54.931,248.022l200.8,201.342L457.328,248l-137.391.008V48h-128V248.015Z' class='ci-primary'/>"];

export { cilArrowThickBottom };

